import React from "react";
import SchoolHero from "../components/SchoolLevels/SchoolHero";
import ActivitiesSection from "../components/ActivitiesSection";
import EventsActivitie from "../components/EventsActivitie";
import ParentEngagement from "../components/ParentEngagement";
import Facilitie from "../components/Facilite";

const Student = () => {
  return (
    <div className="school-level-page">
      <SchoolHero />
      <ActivitiesSection />
      <EventsActivitie />
      <ParentEngagement />
      <Facilitie />
    </div>
  );
};

export default Student;
